import React from 'react';
import { Link } from 'react-router-dom';
//import Newsletter from './Newsletter';
import './Footer.css';
import TermsPrivacyCookieConsentApp from './TermsPrivacyCookieConsentApp';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-links">
          <h3>Quick Links</h3>

          <ul>
            <li><Link to="/about-us">About Us</Link></li>
          </ul>

          <ul>
           
            <li><Link to="/">EPL</Link></li>
            <li><Link to="/la-liga">La Liga</Link></li>
            <li><Link to="/bundes-liga">Bundesliga</Link></li>
            <li><Link to="/serie-a">Serie A</Link></li>
            <li><Link to="/ligue-1">Ligue 1</Link></li>
            <li><Link to="/primeira-liga">Primeira Liga</Link></li>
            <li><Link to="/eredivisie">Eredivisie</Link></li>
            <li><Link to="/brasileiro-serie-a">Brasil Serie A</Link></li>
            <li><Link to="/mls">MLS</Link></li>
            <li><Link to="/spl">SPL</Link></li>
            <li><Link to="/csl">CSL</Link></li>
            {/*<li><a href="/league-tables">League Tables</a></li>
           {/*<li><a href="/contact">Contact</a></li>*/}
          </ul>
        </div>

       {/* <div className="footer-social">
          <h3>Follow Us</h3>
          <ul>
            <li><a href="https://facebook.com">Facebook</a></li>
            <li><a href="https://twitter.com">Twitter</a></li>
            <li><a href="https://linkedin.com">LinkedIn</a></li>
          </ul>
        </div>*/}

        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p> <a href="mailto:contact@footytick.com">contact@footytick.com</a></p>
        </div>

        <div className="footer-legal">
           <h3>Legal</h3>
           <TermsPrivacyCookieConsentApp />
        </div>


      </div>

      {/*<Newsletter />*/}

      <div className="footer-bottom">
        <p>Last updated: February 2026. <br/>FootyTick &copy; 2026. All Rights Reserved.   </p>
      </div>
    </footer>
  );
};

export default Footer;
